<template>
  <main class="container" role="main">
    <div v-if="fcclabels">
      <div
        aria-label="Broadband Facts"
        style=""
        class="row mb-4 bb-facts-container"
      >
        <div class="col-md-12 fcc-title">
          <h3 class="vertical-center">Broadband Facts</h3>
        </div>
        <div class="col w-100 fcc-text">
          <p>
            The FCC has adopted rules that require broadband providers to
            display easy-to-understand labels to allow consumers to comparison
            shop for broadband services.
          </p>
        </div>
        <div class="col-md-12 fcc-link">
          <b-link
            style="margin-top: 6px; margin-bottom: 8px"
            :class="['nav-link']"
            to="/broadband-facts"
            aria-label="The FCC has adopted rules that require broadband providers to display easy-to-understand labels to allow
            consumers to comparison shop for broadband services. Click to get started."
          >
            <span>Get Started</span>
          </b-link>
        </div>
      </div>
    </div>
    <h1>Available Groups</h1>
    <div v-if="currGroups.length === 0" class="error-msg">
      <p>You currently have no groups available.</p>
    </div>
    <div role="navigation" class="card-group" v-else>
      <Card
        v-on="$listeners"
        v-for="group in currGroups"
        :key="group.group_id"
        :data="group"
        type="group"
        :id="group.group_id"
        :name="group.group_name"
        :description="group.group_desc"
        :step="step"
        @advance="handleNext"
      />
    </div>
  </main>
</template>

<script>
import Card from "./Card";

export default {
  name: "Groups",
  components: {
    Card,
  },
  props: {
    step: Number,
    groups: Array,
  },
  data() {
    return {
      currStep: this.step,
      currGroups: [],
      fcclabels: false,
    };
  },
  created() {
    this.currGroups = this.groups;
    this.fcclabels = process.env.VUE_APP_FCCLABELS === "true";
  },
  methods: {
    handleNext(event) {
      this.$emit("advance", [event[0], event[1]]);
    },
    fccLabelForm() {
      this.$emit("fccLabelForm");
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 678px) {
  .fcc-title {
    border-right: none;
    margin-top: 16px;
  }

  .fcc-text {
    margin-top: 20px;
  }
}

a {
  color: white;
  border-radius: 26px;
  text-decoration: none;
  text-align: center;
  background-color: #007bff;
  font-weight: 600;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: left;
}

.card-body {
  display: flex;
  justify-content: space-between;
}

.row p {
  margin-top: 0;
  margin-bottom: 0;
}

h1 {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.card-list {
  display: flex;
  flex-wrap: wrap;
  overflow: scroll;
}

.error-msg {
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  font-size: 20px;
  margin: auto;
  height: 63vh;
}

.vertical-center {
  margin: 0;
  position: absolute;
  top: calc(50% - 2px);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.fcc-title {
  max-width: 17rem;
  display: inline-flex;
  border-right: 3px solid;
}

.fcc-title h3 {
  font-family: "ATTAleckSansBd", sans-serif;
  padding-left: 6px;
}

.fcc-text {
  padding: 0 20px;
  font-size: 0.8rem;
  min-width: 310px;
  display: inline-block;
  padding: 0 20px;
  font-size: 0.8rem;
  min-width: 310px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.fcc-link {
  max-width: 200px;
  min-width: 160px;
}

.bb-facts-container {
  border: 2px solid;
  background-color: white;
  border-radius: 5px;
  padding: 12px;
}
</style>
